var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideMenuMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.00001C1.5 5.83433 1.62088 5.70001 1.77 5.70001L10.23 5.70001C10.3791 5.70001 10.5 5.83433 10.5 6.00001C10.5 6.1657 10.3791 6.30001 10.23 6.30001L1.77 6.30001C1.62088 6.30001 1.5 6.1657 1.5 6.00001Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenuMinus);
export default __webpack_public_path__ + "static/media/sideMenuMinus.44938dc80bbc475b717e691707734e8b.svg";
export { ForwardRef as ReactComponent };